// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lJtV","col":"styles_col__3Enur"};